import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import cairoImg from './img/img-cairo.png'
import backgroundImg from './img/background.jpg'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  locale = 'pt-BR',
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale).format(
    new Date(weddingDate.timestamp)
  )

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro382">
      <div className="full-project screen">
        <img
          className="background-KqxCzi"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="button-KqxCzi">
          <p
            className="site-de-casamento-e-FRZ0F7"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-FRZ0F7 smart-layers-pointers">
            <div className="pular-introduo-kvlGz8" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="content-KqxCzi">
          <div className="couple-name-and-date-YoNpCp">
            <div className="couple-name-1PJ2W9">
              <h1 className="title-LBHx5B bp2-animate-enter">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom &&
                  ` & ${coupleSimplifiedName.groom}`}
              </h1>
            </div>
            <div className="date-1PJ2W9 date">
              <div className="date-APKWul date lg---warning bp2-animate-enter1">
                {date}
              </div>
            </div>
          </div>
          <img
            className="img-cairo-hero3x-YoNpCp"
            src={cairoImg}
            alt="img-Cairo-hero@3x"
          />
        </div>
      </div>
      <div className="animated-intro-large screen">
        <img
          className="background-p4EdWL"
          src={background || backgroundImg}
          alt="Background"
        />

        <div className="button-p4EdWL">
          <p
            className="site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-CpwLjN smart-layers-pointers">
            <div className="pular-introduo-fo8x79" onClick={onSkipIntro}>
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="content-p4EdWL">
          <div className="couple-name-and-date-Vpi3WB">
            <div className="couple-name-j7jiJz">
              <h1 className="title-gxV2hH bp1-animate-enter">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom &&
                  ` & ${coupleSimplifiedName.groom}`}
              </h1>
            </div>
            <div className="date-j7jiJz date">
              <div className="date-lT18sc date sm---content bp1-animate-enter1">
                {date}
              </div>
            </div>
          </div>
          <img
            className="img-cairo-hero3x-Vpi3WB"
            src={cairoImg}
            alt="img-Cairo-hero@3x"
          />
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
